module.exports = __webpack_public_path__ + "img/ly.c02dc904.svg";